import car from '@images/airdrop/car.webp';
import rocket from '@images/airdrop/rocket.webp';
import rose from '@images/airdrop/rose.webp';
import toilet from '@images/airdrop/toilet.webp';
import { type IAirdropBox } from '@type/airdrop';
import { I18n } from '@utils/index';

/**
 * 空投封面
 */
export const airdropCover: { [key: string]: IAirdropBox } = {
  /** 花样式的空投箱 */
  flower: 'FLOWER',
  /** 小轿车样式的空投箱 */
  car: 'CAR',
  /** 马桶样式的空投箱 */
  toilet: 'TOILET',
  /** 火箭样式的空投箱 */
  rocket: 'ROCKET'
};
/** 默认用户昵称 */
export const defaultNickname = {
  nickName: I18n.t('iwtH4FdE')
};

/** 空投箱Key */
export const boxNames = airdropCover;

/**
 * 发放的红包状态
 */
export const airdropStatus = {
  /** 退款中 */
  refunding: 7,
  /** 退款失败 */
  refundFail: 8,
  // 退款成功
  refundSuccess: 9,
  /** 过期 */
  expired: 6,
  /** 领取完成 */
  drew: 3,
  /** 进行中 */
  drewing: 1
};

/**
 * 领取的红包状态
 */
export const airdropReceiveStatus = {
  /** 过期 */
  expired: 6,
  /** 激活成功 */
  activeSuccess: 5,
  /** 待激活 */
  noActive: 2
};

/** 新人专享空投活动编码 */
export const airdropCode = {
  /** KIKI AirDrop New User */
  code: 'KANU'
}

export const airdropAssignType = {
  /** 幸运空投 */
  fortune: 'FORTUNE',
  /** 普通空投 */
  general: 'GENERAL'
};

export const boxCover = {
  [boxNames.car]: car,
  [boxNames.flower]: rose,
  [boxNames.rocket]: rocket,
  [boxNames.toilet]: toilet
};

export const boxAnimation = {
  [boxNames.car]: '/animations/airdrop/car.json',
  [boxNames.flower]: '/animations/airdrop/flower.json',
  [boxNames.rocket]: '/animations/airdrop/rocket.json',
  [boxNames.toilet]: '/animations/airdrop/toilet.json'
}

export const getGreeting = () => ({
  [boxNames.car]: I18n.t('greeting_car'),
  [boxNames.flower]: I18n.t('greeting_flower'),
  [boxNames.rocket]: I18n.t('greeting_rocket'),
  [boxNames.toilet]: I18n.t('greeting_toilet')
})
